import { ReactNode } from "react";

import { ConflictsBadge, EhrDataBadge, MissingDataBadge, SyncedBadge } from "@/src/components/cards/common";
import { ValerieCard } from "@/src/components/valerie-card";
import { cn } from "@/src/lib/shadcn-utils";

interface EHRCardProps {
  icon: ReactNode;
  title: string;
  children: ReactNode;
  className?: string;
  missingData?: boolean;
  showSyncBadge?: boolean;
  showEhrDataBadge?: boolean;
  hasAnyConflicts?: boolean;
}

export default function EHRCard({
  icon,
  title,
  children,
  className,
  missingData = false,
  showSyncBadge = true,
  showEhrDataBadge = true,
  hasAnyConflicts = false,
}: EHRCardProps) {
  return (
    <ValerieCard
      title={title}
      icon={icon}
      className={cn("w-full", className)}
      actions={
        <>
          {showSyncBadge && (hasAnyConflicts ? <ConflictsBadge /> : <SyncedBadge />)}
          {showEhrDataBadge && (missingData ? <MissingDataBadge /> : <EhrDataBadge />)}
        </>
      }
    >
      {children}
    </ValerieCard>
  );
}
